(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["at-footer-keyword-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('at-footer-keyword-tabs')) {
    customElements.define(
      'at-footer-keyword-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-panel]'));
          if (!this.tabs.length) return;
          this.querySelector('.at-keyword-tabs__nav').setAttribute('role', 'tablist');
          this.tabs.forEach((tab) => {
            tab.setAttribute('role', 'tab');
            tab.addEventListener('click', () => this.select(tab), options);
            tab.addEventListener(
              'keydown',
              (event) => {
                if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
                event.preventDefault();
                const index = this.tabs.indexOf(tab);
                let next =
                  event.key === 'Home'
                    ? 0
                    : event.key === 'End'
                    ? this.tabs.length - 1
                    : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
                this.select(this.tabs[next]);
                this.tabs[next].focus();
              },
              options
            );
          });
          this.panels.forEach((panel) => {
            panel.setAttribute('role', 'tabpanel');
            panel.tabIndex = 0;
          });
          this.select(this.tabs[0]);
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              if (!this.contains(event.target)) return;
              const block = event.target.closest('[data-tab], [data-panel]');
              const id = block?.dataset.tab || block?.dataset.panel;
              const tab = this.tabs.find((item) => item.dataset.tab === id);
              if (tab) this.select(tab);
            },
            options
          );
        }
        disconnectedCallback() {
          this.controller?.abort();
        }
        select(selected) {
          this.tabs.forEach((tab) => {
            const active = tab === selected;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });
          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.panel !== selected.dataset.tab;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["at-itinerary-accordion"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const init = root => {

      if (!root || root.dataset.accordionReady === 'true') return;

      root.dataset.accordionReady = 'true';

      const items = [...root.querySelectorAll('[data-at-accordion-item]')];

      const shareButton = root.querySelector('[data-at-itinerary-share]');

      const shareStatus = root.querySelector(
        '[data-at-itinerary-share-status]'
      );


      const openPanel = (item, animate = true) => {

        const button = item.querySelector(
          '[data-at-accordion-toggle]'
        );

        const panel = item.querySelector(
          '[data-at-accordion-panel]'
        );

        item.classList.add('is-open');

        button.setAttribute('aria-expanded', 'true');

        panel.style.visibility = 'visible';

        if (
          !animate ||
          matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
          panel.style.height = 'auto';
          return;
        }

        panel.style.height = '0px';

        requestAnimationFrame(() => {

          panel.style.transition =
            'height .42s cubic-bezier(.22,.61,.36,1)';

          panel.style.height =
            panel.scrollHeight + 'px';

        });

        panel.addEventListener(
          'transitionend',
          () => {

            panel.style.height = 'auto';

            panel.style.transition = '';

          },
          { once: true }
        );

      };


      const closePanel = (item, animate = true) => {

        const button = item.querySelector(
          '[data-at-accordion-toggle]'
        );

        const panel = item.querySelector(
          '[data-at-accordion-panel]'
        );

        button.setAttribute('aria-expanded', 'false');

        item.classList.remove('is-open');

        if (
          !animate ||
          matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {

          panel.style.height = '0px';

          panel.style.visibility = 'hidden';

          return;

        }

        panel.style.height =
          panel.scrollHeight + 'px';

        requestAnimationFrame(() => {

          panel.style.transition =
            'height .36s cubic-bezier(.4,0,.2,1)';

          panel.style.height = '0px';

        });

        panel.addEventListener(
          'transitionend',
          () => {

            panel.style.visibility = 'hidden';

            panel.style.transition = '';

          },
          { once: true }
        );

      };


      items.forEach(item => {

        const button = item.querySelector(
          '[data-at-accordion-toggle]'
        );

        if (item.classList.contains('is-open')) {
          openPanel(item, false);
        }

        button.addEventListener('click', () => {

          if (item.classList.contains('is-open')) {
            closePanel(item);
          } else {
            openPanel(item);
          }

        });

      });


      shareButton?.addEventListener(
        'click',
        async () => {

          const shareData = {
            title:
              shareButton.dataset.shareTitle ||
              document.title,
            url: window.location.href
          };

          try {

            if (navigator.share) {

              await navigator.share(shareData);

            } else {

              await navigator.clipboard.writeText(
                shareData.url
              );

              if (shareStatus) {
                shareStatus.textContent = 'Link copied';
              }

            }

          } catch (error) {

            if (
              error.name !== 'AbortError' &&
              shareStatus
            ) {
              shareStatus.textContent =
                'Unable to share';
            }

          }

        }
      );

    };


    document
      .querySelectorAll('[data-at-accordion-itinerary]')
      .forEach(init);


    document.addEventListener(
      'shopify:section:load',
      event =>
        init(
          event.target.querySelector(
            '[data-at-accordion-itinerary]'
          )
        )
    );

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["at-package-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      if (!root || root.dataset.faqReady === 'true') return;
      root.dataset.faqReady = 'true';

      root.querySelectorAll('[data-at-faq-toggle]').forEach(button => {
        button.addEventListener('click', () => {
          const item = button.closest('[data-at-faq-item]');
          const panel = item.querySelector('[data-at-faq-panel]');
          const opening = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(opening));
          item.classList.toggle('is-open', opening);
          panel.style.visibility = 'visible';

          if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
            panel.style.height = opening ? 'auto' : '0px';
            panel.style.visibility = opening ? 'visible' : 'hidden';
            return;
          }

          if (opening) {
            panel.style.height = '0px';
            requestAnimationFrame(() => {
              panel.style.transition = 'height .38s cubic-bezier(.22,.61,.36,1)';
              panel.style.height = panel.scrollHeight + 'px';
            });
            panel.addEventListener('transitionend', () => {
              panel.style.height = 'auto';
              panel.style.transition = '';
            }, { once: true });
          } else {
            panel.style.height = panel.scrollHeight + 'px';
            requestAnimationFrame(() => {
              panel.style.transition = 'height .32s cubic-bezier(.4,0,.2,1)';
              panel.style.height = '0px';
            });
            panel.addEventListener('transitionend', () => {
              panel.style.visibility = 'hidden';
              panel.style.transition = '';
            }, { once: true });
          }
        });
      });
    };

    document.querySelectorAll('[data-at-faq-accordion]').forEach(init);
    document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-at-faq-accordion]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
